module.exports = __webpack_public_path__ + "img/eliza-ivanova-untitled.e8d0e5a.jpg";